import { Pie } from "react-chartjs-2";
import "chart.js/auto";
import BaseListPage from "../../../../base/BaseListPage";
import withRouter from "../../../../withRouter";
import {
  countObjectUseCase,
  findObjectUseCase,
} from "../../../../usecases/object";
import TransTypeDistributionPresenter from "./TransTypeDistributionPresenter";
import Export from "../../../../components/Export";
import printChart from "../../../../PrintChart";
import DateRangeReport from "../../../../components/DateRangeReport";
import Select from "react-select";
import DefaultState from "../../../sales-and-transactions/components/DefaultState";
import InitialPrompt from "../../../../components/InitialPrompt";
import SalesPieReport from "./components/SalesPieReport";
import { exportTransactionTypeDistributionCSV } from "./utils/transactionTypeDistributionCsvUtils";
import ProgressLoader from "../../../../components/ProgressLoader";

class TransTypeDistributionPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new TransTypeDistributionPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase()
    );
    this.state = {
      objects: [],
      startDate: "",
      endDate: "",
      selectedStoreCode: "",
      store: [],
      storess: "",
      range: "",
      notFound: false,
    };
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handleStoreCodeChange = this.handleStoreCodeChange.bind(this);
  }

  getCollectionName() {
    return "transactions";
  }

  setStore(store) {
    this.setState({ store });
  }

  onChangeStore(where) {
    this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }

  onChangeDate(where) {
    this.presenter.onChangeDate(where);
    this.setState({ range: where });
  }

  getUniqueStoreCodes() {
    const storeCodes = this.state.objects.map((obj) => {
      return obj.store_code.replace("ANGELSPIZZA_", "");
    });

    return [...new Set(storeCodes)]; // Remove duplicates
  }

  handleStartDateChange(event) {
    this.setState({ startDate: event.target.value });
  }

  handleEndDateChange(event) {
    this.setState({ endDate: event.target.value });
  }

  handleStoreCodeChange(event) {
    this.setState({ selectedStoreCode: event.target.value });
  }

  filterTransactions() {
    const { objects, startDate, endDate, selectedStoreCode } = this.state;

    return objects
      .filter((status) => status.status === "C")
      .filter((transaction) => {
        const transactionDate = new Date(transaction.createdAt);
        const start = startDate
          ? new Date(startDate)
          : new Date(-8640000000000000);
        const end = endDate ? new Date(endDate) : new Date();
        end.setHours(23, 59, 59, 999);
        const isDateInRange =
          (!startDate || transactionDate >= start) &&
          (!endDate || transactionDate <= end);
        const isStoreCodeMatch = selectedStoreCode
          ? transaction.store_code === `ANGELSPIZZA_${selectedStoreCode}`
          : true;

        return isDateInRange && isStoreCodeMatch;
      });
  }

  chartData(objects) {
    const filteredTransactions = this.filterTransactions();
    let counts = { D: 0, T: 0, G: 0, P: 0, U: 0, B: 0, U: 0, K: 0, F: 0 };
    filteredTransactions.forEach((item) => {
      if (counts.hasOwnProperty(item.tran_type)) {
        counts[item.tran_type]++;
      }
    });
    return {
      labels: [
        "Dine-in",
        "Take-out",
        "GrabFood",
        "Delivery",
        "Drive-Thru",
        "FoodPanda",
      ],
      datasets: [
        {
          label: "Transaction Types",
          data: [counts.D, counts.T, counts.G, counts.U, counts.K, counts.F],
          backgroundColor: [
            "#1b74bb",
            "#37c6f4",
            "#ffcf39",
            "pink",
            "green",
            "#db3373",
          ],
          borderColor: [
            "#1b74bb",
            "#37c6f4",
            "#ffcf39",
            "pink",
            "green",
            "#db3373",
          ],
          borderWidth: 1,
        },
      ],
    };
  }

  chartOption() {
    return {
      responsive: true,
      maintainAspectRatio: false,
      aspectRatio: 2,
      plugins: {
        legend: {
          position: "top",
        },
        title: {
          display: true,
          text: "Transaction Type Distribution",
        },
      },
    };
  }

  exportToCSV = () => {
    const { range, storess } = this.state;
    const chartData = this.chartData(this.state.objects);

    exportTransactionTypeDistributionCSV({
      chartData,
      storeName: storess,
      range,
      // fileName: 'CustomFilename.csv'
    });
  };

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }

  render() {
    const { objects, storess, range } = this.state;

    const data = this.chartData(objects);
    const options = this.chartOption();

    const chartId = "chart-container9";
    const formatSales = (sales) => {
      return sales.toLocaleString("en-US", {
        style: "currency",
        currency: "PHP",
      });
    };

    const storeOptions = [
      ...this.state.store.map((code) => ({
        value: code.name,
        label: code.name,
      })),
    ];

    const selectedOption = storeOptions.find(
      (opt) => opt.value === this.state.selectedStoreCode
    );

    return (
      <>
        <div className="d-flex justify-content-between align-items-center mb-1 mt-4">
          <h2 className="fw-bold text-capitalize">
            <span style={{ color: "#83c14a" }}> Transaction Type</span>
            <span style={{ color: "black" }}> Distribution</span>
          </h2>
          <Export
            exportCsv={this.exportToCSV}
            exportPdf={() => printChart(chartId)}
          />
        </div>
        <div className="row mb-2">
          <div className="col-sm-4" style={{ maxWidth: "max-content" }}>
            <DateRangeReport
              onChange={this.onChangeDate.bind(this)}
              field="tran_date"
            />
          </div>
          <div className="col-sm-4">
            <Select
              options={storeOptions}
              value={selectedOption}
              onChange={(opt) => this.onChangeStore(opt.value)}
              placeholder="Select Store"
              isClearable={false}
              className="basic-single"
              classNamePrefix="select"
            />
          </div>
        </div>

        <ProgressLoader
          loaded={this.state.objects?.length}
          total={this.state.count}
          getProgressPercentage={() => this.getProgressPercentage()}
        />
        {this.state.objects && this.state.objects.length > 0 ? (
          <SalesPieReport
            data={data}
            options={options}
            formatSales={formatSales}
            storess={storess}
            range={range}
            chartRef={this.chartRef9}
            containerId="chart-container9"
          />
        ) : this.state.notFound ? (
          <div className="text-center mt-5">
            <p className="text-muted fs-5">
              📭 Data not found for selected filter.
            </p>
          </div>
        ) : this.state.storess && this.state.range && !this.state.notFound ? (
          <div className="text-center mt-5">
            <DefaultState />
          </div>
        ) : (
          <InitialPrompt twoFilter={true} />
        )}
      </>
    );
  }
}

export default withRouter(TransTypeDistributionPage);
